import { useQuery } from '@tanstack/react-query';
import { MessageSquare } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { SmsThread } from '@/modules/messagerie/SmsThread';
import { getConversationByContact } from '@/modules/messagerie/api';

interface Props {
  contactId: string;
  telephoneMobile: string;
}

// Encart SMS affiché sur la fiche client : le fil d'échange + la zone de rédaction.
export function ClientSmsCard({ contactId, telephoneMobile }: Props) {
  const convQ = useQuery({
    queryKey: ['sms-conversation', contactId],
    queryFn: () => getConversationByContact(contactId),
  });

  const mobile = telephoneMobile.trim();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <MessageSquare className="h-4 w-4" /> SMS
        </CardTitle>
      </CardHeader>
      <CardContent>
        {!mobile ? (
          <p className="text-sm text-muted-foreground">
            Renseignez un numéro de mobile pour envoyer et recevoir des SMS avec ce client.
          </p>
        ) : (
          <div className="h-[380px]">
            <SmsThread
              conversationId={convQ.data?.id ?? null}
              telephone={mobile}
              contactId={contactId}
              optOut={convQ.data?.statut === 'opt_out'}
              onSent={() => {
                void convQ.refetch();
              }}
            />
          </div>
        )}
      </CardContent>
    </Card>
  );
}
